export const BUTTON = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ButtonElement';
